import { createFeatureSelector, createSelector } from '@ngrx/store';

import { HelpCenterState, helpCenterFeatureKey } from './help-center.reducer';

export const selectHelpCenterState = createFeatureSelector<HelpCenterState>(helpCenterFeatureKey);

export const selectHelpCenterSettings = createSelector(selectHelpCenterState, (state) => state.helpCenterSettings);

export const selectIsLoading = createSelector(selectHelpCenterState, (state) => state.isLoading);
